<template>
  <div class="body">
      <div class="title-box">
        <h3>{{spreadCommissionLan.spreadCommission}}</h3>
      </div>
      <div class="spreadCommission">
        <!-- <h4 class="title">{{spreadCommissionLan.spreadCommission}}</h4> -->
        <table class="table  tableData table-striped">
          <thead>
            <tr>
              <th>{{spreadCommissionLan.th.symbol}}</th>
              <th>{{spreadCommissionLan.th.Commission}}</th>
              <th>{{spreadCommissionLan.th.lastUpdate}}</th>
              <th>{{spreadCommissionLan.th.operate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in data">
              <td v-if="item.newItem">
                <el-select v-model="item.SYMBOL" :placeholder="spreadCommissionLan.placeholder">
                  <el-option
                    v-for="data in item.selecteData"
                    :key="data.value"
                    :label="data.label"
                    :value="data.label"
                    >
                  </el-option>
                </el-select>
              </td>
              <td v-else>{{item.SYMBOL}}</td>
              <td>
                <el-input class="commission" v-model="item.COMMISSION" @change="item.changed = true"></el-input>
              </td>
              <td>{{item.LAST_UPDATE}}</td>
              <td v-if="index < data.length-1">
                 <button class="btn btn-xs" style="background-color:#3f51b5;color:#fff;" @click="addItem(item,data)">{{spreadCommissionLan.th.add}}</button>
                 <button class="btn btn-xs" style="background-color:#f08712;color:#fff;" @click="removeItem(item,data)">{{spreadCommissionLan.th.remove}}</button>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="input-group-btn">
          <button class="btn bg-teal" type="submit" @click="submitFn">{{spreadCommissionLan.th.save}}</button>
        </div>
        <Modal v-model="showModal" size="sm" :header="false" :footer="false">
                <div v-show="!sucSave">
                    <i class="glyphicon glyphicon-warning-sign color-red"></i>
                    <span class="color-red">{{spreadCommissionLan.submitResult.err}}</span>
                </div>
                <div v-show="sucSave">
                    <i class="glyphicon glyphicon-ok color-green"></i>
                    <span class="color-green">{{spreadCommissionLan.submitResult.succeed}}</span>
                </div>
        </Modal>
  </div>
</template>

<script>
import { Modal } from 'uiv'
import { Api } from 'api/commissionEnv'
import { URL_SYMBOLOTHER,URL_SYMBOLSPREAD,URL_SYMBOLDEL } from 'api/commissionApi'
var api = new Api()

export default {
  props: ['IBregion'],
  components: {
    Modal
  },
  watch: {
    IBregion (curVal,oldVal) {
      this.pageInit()
    }
  },
  mixins: [
    require("common/mixin/base.js").base({spreadCommissionLan:"spreadCommissionMappingReport"}),
  ],
  data () {
    return {
      showModal: false,
      sucSave: false,
      data: [],
      editData: {
        data: [],
        user: '',
      }, 
    }
  },
  mounted () {
    this.pageInit()
  },
  methods: {
    // 初始化数据
    pageInit () {
        if (this.IBregion == 'GM') api.switchGMPort()
        else if (this.IBregion == 'UK') api.switchUKPort()
        this.$http.get(api.getUrl20(URL_SYMBOLSPREAD)).then((res) => {
        this.data = res.data.data
        this.data.forEach((item,index) => {
          if(item.SYMBOL == 'OTHER'){
            let obj = this.data.splice(index,1)[0]
            this.data.splice(this.data.length,0,obj)
          }
        })
      })
    },
    // 提交
    submitFn () {
      this.data.forEach((item,index) =>{
        if (item.changed && item.SYMBOL && item.COMMISSION) {
          let tem = {SYMBOL:item.SYMBOL,COMMISSION:item.COMMISSION}
          this.editData.data.push(tem)
          this.editData.user = JSON.parse(sessionStorage.user).user_name
          item.changed = false
        }
      })
      if (this.editData.data.length > 0) {
        this.$http.post(api.getUrl20(URL_SYMBOLSPREAD),this.editData).then((res) => {
          if (res.data.code == 200 && res.data.data == 'SUCCESS' && res.data.msg == 'OK') {
            this.showModal = true
            this.sucSave = true
            this.pageInit()
          }else{
            this.showModal = true
            this.sucSave = false
          }
          this.editData.data = []
          this.editData.user = ''
        })
      }else return 
    },
    // 添加一行
    addItem (item,arr) {
      let code = arr.indexOf(item)+1
      let obj = {
        COMMISSION: '',
        newItem : true,
        LAST_UPDATE : new Date().toLocaleString(),
        selecteData: [],
        SYMBOL: ''
      }
      this.$http.get(api.getUrl20(URL_SYMBOLOTHER)).then((res) => {
        res.data.data.forEach((item,index) => {
          let tem = {value: index,label: item}
          obj.selecteData.push(tem)
        })
      })
      arr.splice(code,0,obj)
    },
    // 删除一行
    removeItem (item,arr) {
      let msg = this.spreadCommissionLan.confirmDeleteText
      if (confirm(msg) == true) {
        let code = arr.indexOf(item)
        if (arr.length>1){
          let item = arr.splice(code,1)[0]
          let deleteData = {symbol: item.SYMBOL,user:JSON.parse(sessionStorage.user).user_name}
          this.$http.post(api.getUrl20(URL_SYMBOLDEL),deleteData).then((res) => {
            if (res.data.code == 200 && res.data.data == 'SUCCESS' && res.data.msg == 'OK') {
              this.showModal = true
              this.sucSave = true
            }else{
              this.showModal = true
              this.sucSave = false
            }
          })
        }else {
          for (let key in item) {
            item[key] = ''
          }
        }
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.body{
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 60px;
  .title-box{
      border: 1px solid #3F51B5;
      background: #3F51B5;
      padding: 0 20px;
      color: #fff;
      border-radius: 5px 5px 0 0;
    }
  .spreadCommission{
    border: 1px solid #ddd;
    border-radius: 3px;
    .title{
      line-height: 40px;
      margin-left:20px;
      font-size: 15px;
      color: #3F51B5;
      font-weight: 550;
    }
    .tableData{
      // border-top:2px solid #3F51B5;
      thead{
        background-color: #EBEDF7;
      }
      th,td{
        border-left: 1px solid #ddd;
      }
      th:first-child,td:first-child{
        border-left:0;
      }
      .commission{
        width: 30%;
      }
    }
  }
  .input-group-btn{
    text-align: center;
    button{
      width: 120px;
      margin-top: 20px;
      border-radius: 3px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// spreadCommissionMappingReport.vue?6cc4f940